/**
 * The consent language shown whenever the partner's own disclosure is
 * unavailable — the TCPA Search failed, returned no record, or returned a
 * record with an empty disclaimer.
 *
 * A consent checkbox must never render without language attached to it, so
 * this is the single approved fallback. Keep it identical everywhere: the
 * certificate captures whatever text sits in the disclosure label verbatim,
 * and buyers reject leads whose wording differs from what was approved.
 */
export const DEFAULT_TCPA_DISCLOSURE =
  'I acknowledge that, by clicking the checkbox as my official signature, I consent to representatives of onlinecollegeguide.io and our Partner Schools contacting me about educational opportunities via email, text, or phone, number(s) , using an automatic dialer. Message and data rates may apply. I understand that my consent is not a requirement for enrollment, and I may withdraw my consent at any time.'
